/* eslint-disable no-useless-escape */
// credit: https://stackoverflow.com/a/901144
export default function getQueryParam(name, url) {
	if (!url && typeof window !== 'object') {
		return undefined;
	}
	url = url || window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	let results = regex.exec(url);
	if (!results) return undefined;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Ripped from the depths of statjoy.js
// https://github.com/cratejoy/statjoy.js/blob/master/dist/statjoy.js#L2817
export const parseQuery = (search) => {
	if (!search) return {};
	const args = search.substring(1).split('&');
	let argsParsed = {};
	let i, arg, kvp, key, value;

	for (i=0; i < args.length; i++) {
		arg = args[i];

		if (-1 === arg.indexOf('=')) {
			argsParsed[decodeURIComponent(arg).trim()] = true;
		} else {
			kvp = arg.split('=');
			key = decodeURIComponent(kvp[0]).trim();
			value = decodeURIComponent(kvp[1]).trim();
			argsParsed[key] = value;
		}
	}

	return argsParsed;
};
